import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MonbureauComponent} from './monbureau.component';
import {MonbureauRoutingModule} from './monbureau-routing.module';
import {SharedModule} from '../shared/shared.module';
import {CoreModule} from '../core/core.module';
import {DesktopDropMenuComponent} from "./desktop-drop-menu/desktop-drop-menu.component";
import {DesktopButtonComponent} from "./desktop-button/desktop-button.component";

@NgModule({
  imports: [
    CommonModule,
    MonbureauRoutingModule,
    SharedModule,
    CoreModule
  ],
  declarations: [MonbureauComponent, DesktopButtonComponent, DesktopDropMenuComponent],
  exports:[
    MonbureauComponent
  ]
})
export class MonbureauModule { }
